// utils/loadable.js
import React, { lazy, Suspense, useEffect } from 'react'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 创建带进度条的加载组件
export const LoadingWithProgress = () => {
  useEffect(() => {
    NProgress.start()
    
    return () => {
      NProgress.done()
    }
  }, [])
  
  return <div />
}

// 新的 loadable 函数，使用 React.lazy 并保留进度条
const loadable = (importFunc) => {
  const LazyComponent = lazy(importFunc)
  
  return (props) => (
    <Suspense fallback={<LoadingWithProgress />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}

export default loadable